module.exports = __webpack_public_path__ + "img/icon-canceled-2.059b743f.svg";